// extracted by mini-css-extract-plugin
export default {"LogoLarge":"LogoLarge_LogoLarge__oMCpb"};